import { render, staticRenderFns } from "./SelectedParticipantFields.vue?vue&type=template&id=b60360c4&scoped=true"
import script from "./SelectedParticipantFields.vue?vue&type=script&lang=js"
export * from "./SelectedParticipantFields.vue?vue&type=script&lang=js"
import style0 from "./SelectedParticipantFields.vue?vue&type=style&index=0&id=b60360c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60360c4",
  null
  
)

export default component.exports